// extracted by mini-css-extract-plugin
module.exports = {"panel":"customSound-module--panel--2K1bJ"};